/* eslint react/prop-types:0 */
import React from 'react';

import {
	CONTAINER_ADMIN_HOME_ID,
	CONTAINER_HOME_ID,
} from '@confluence/app-navigation/entry-points/navigationIDs';
import { LoadablePaint } from '@confluence/loadable';
import { getIsNav4Enabled } from '@confluence/nav4-enabled';

const SpaceSettingsDataClassificationRouteComponent = LoadablePaint({
	loader: () =>
		import(
			/* webpackChunkName: "loadable-SpaceSettingsDataClassificationRouteComponent" */ './SpaceSettingsDataClassificationComponent'
		),
});

export const SpaceSettingsDataClassificationRoute = ({ params: { spaceKey } }) => (
	<SpaceSettingsDataClassificationRouteComponent spaceKey={spaceKey} />
);

SpaceSettingsDataClassificationRoute.NAVIGATION_PARAMS = ({ name, params: { spaceKey } }) => ({
	Screen: {
		screenEvent: { name: 'spaceSettingsDataClassification', id: spaceKey },
		pageState: { spaceKey, routeName: name },
	},
	MainLayout: {
		navView: getIsNav4Enabled() ? CONTAINER_ADMIN_HOME_ID : CONTAINER_HOME_ID,
		spaceKey,
		disableMinWidth: true,
	},
});
